import { IconButton, styled } from '@mui/material'

export const StyledIconButton = styled(IconButton)(({ theme }) => ({
    position: 'absolute',
    top: `-${theme.spacing(2)}`,
    right: theme.spacing(3),
}))
